export default function TemplatesTabContent({style}) {
    return (
        <h3>Templates content here</h3>
    );
};